// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/project.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_ontology_resources_project } from "../resources/project_pb.js";
import { file_services_project_resources_project_configuration_project_configuration } from "../../project/resources/project_configuration/project_configuration_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/ontology/api/project.proto.
 */
export const file_services_ontology_api_project = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public, file_services_ontology_resources_project, file_services_project_resources_project_configuration_project_configuration, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.ontology.api.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 0);

/**
 * Describes the message gx.ontology.api.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 1);

/**
 * Describes the message gx.ontology.api.ListProjectsRequest.
 * Use `create(ListProjectsRequestSchema)` to create a new message.
 */
export const ListProjectsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 2);

/**
 * Describes the message gx.ontology.api.ListProjectsResponse.
 * Use `create(ListProjectsResponseSchema)` to create a new message.
 */
export const ListProjectsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 3);

/**
 * Describes the message gx.ontology.api.ListProjectsCountRequest.
 * Use `create(ListProjectsCountRequestSchema)` to create a new message.
 */
export const ListProjectsCountRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 4);

/**
 * Describes the message gx.ontology.api.ListProjectsCountResponse.
 * Use `create(ListProjectsCountResponseSchema)` to create a new message.
 */
export const ListProjectsCountResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 5);

/**
 * Describes the message gx.ontology.api.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 6);

/**
 * Describes the message gx.ontology.api.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 7);

/**
 * Describes the message gx.ontology.api.CreateProjectSourcesRequest.
 * Use `create(CreateProjectSourcesRequestSchema)` to create a new message.
 */
export const CreateProjectSourcesRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 8);

/**
 * Describes the message gx.ontology.api.CreateProjectSourcesResponse.
 * Use `create(CreateProjectSourcesResponseSchema)` to create a new message.
 */
export const CreateProjectSourcesResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 9);

/**
 * Describes the message gx.ontology.api.UpdateProjectRequest.
 * Use `create(UpdateProjectRequestSchema)` to create a new message.
 */
export const UpdateProjectRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 10);

/**
 * Describes the message gx.ontology.api.UpdateProjectResponse.
 * Use `create(UpdateProjectResponseSchema)` to create a new message.
 */
export const UpdateProjectResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 11);

/**
 * Describes the message gx.ontology.api.DeleteProjectRequest.
 * Use `create(DeleteProjectRequestSchema)` to create a new message.
 */
export const DeleteProjectRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 12);

/**
 * Describes the message gx.ontology.api.DeleteProjectResponse.
 * Use `create(DeleteProjectResponseSchema)` to create a new message.
 */
export const DeleteProjectResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 13);

/**
 * Describes the message gx.ontology.api.DeleteProjectSourceRequest.
 * Use `create(DeleteProjectSourceRequestSchema)` to create a new message.
 */
export const DeleteProjectSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 14);

/**
 * Describes the message gx.ontology.api.DeleteProjectSourceResponse.
 * Use `create(DeleteProjectSourceResponseSchema)` to create a new message.
 */
export const DeleteProjectSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_project, 15);

/**
 * @generated from service gx.ontology.api.ProjectService
 */
export const ProjectService = /*@__PURE__*/
  serviceDesc(file_services_ontology_api_project, 0);

